import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpEventType, HttpErrorResponse } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { StorageService } from './../../../../../services/API/storage/storage.service';

@Component({
    selector: 'app-upload-file',
    templateUrl: './upload-file.component.html',
    styleUrls: ['./upload-file.component.css'],
    standalone: false
})
export class UploadFileComponent implements OnInit {

  files: File[] = [];
  path: string = "";
  toUpload = 0;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private storageService: StorageService, private dialogRef: MatDialogRef<UploadFileComponent>) { }

  ngOnInit(): void {
    this.path = this.data['path'];
    console.log(this.path);
  }

  onSelect(event: any) {
    console.log(event);
    this.files.push(...event.addedFiles);
  }

  onRemove(event: any) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  save() {
    this.toUpload = this.files.length;
    for (var i = 0; i < this.files.length; i++) {
      this.uploadFile(this.files[i]);
    }
  }

  close() {
    this.dialogRef.close();
  }

  uploadFile(file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('path', this.path);
    file.inProgress = true;
    this.storageService.upload(formData).pipe(map(event => {
      switch (event.type) {
        case HttpEventType.UploadProgress:
          file.progress = Math.round(event.loaded * 100 / event.total);
          console.log(file.progress);
          if(file.progress == 100){
            this.toUpload = this.toUpload - 1;
            if(this.toUpload == 0){
              this.dialogRef.close({'upload': true});
            }
          }
          break;
        case HttpEventType.Response:
          return event;
      }
    }), catchError((error: HttpErrorResponse) => {
      file.inProgress = false;
      return of(`Upload failed: ${file.data.name}`);
    })).subscribe((event: any) => {
      if (typeof (event) === 'object') {
        console.log(event.body);
      }
    });
  }
}
